import { render, staticRenderFns } from "./AAvatarV4.vue?vue&type=template&id=5c0cf4d7&scoped=true&"
import script from "./AAvatarV4.vue?vue&type=script&lang=js&"
export * from "./AAvatarV4.vue?vue&type=script&lang=js&"
import style0 from "./AAvatarV4.vue?vue&type=style&index=0&id=5c0cf4d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cf4d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
